// extracted by mini-css-extract-plugin
export default {"root":"SignUpForm_root__1LMCl","inputLink":"SignUpForm_inputLink__yS4xI","after":"SignUpForm_after__h-FQ2","eyeIcon":"SignUpForm_eyeIcon__F9ypl"};